import PropTypes from 'prop-types';
import React from 'react';
import styles from './reverseDirection.scss';
import cx from 'classnames';

class ReverseDirection extends React.Component {
  /**
   * Render html throught jsx
   * @returns html
   */
  render() {
    return (
      <div
        className={
          styles['reverse--direction'] +
          ' ' +
          cx(
            { [styles[`justify--xs--${this.props.xs}`]]: this.props.xs },
            { [styles[`justify--sm--${this.props.sm}`]]: this.props.sm },
            { [styles[`justify--md--${this.props.md}`]]: this.props.md },
            { [styles[`justify--lg--${this.props.lg}`]]: this.props.lg }
          )
        }
      >
        {this.props.children}
      </div>
    );
  }
}

const alignments = ['left', 'right', 'center'];

ReverseDirection.propTypes = {
  /** Alignment for the xs breakpoint */
  xs: PropTypes.oneOf(alignments),
  /** Alignment for the sm breakpoint */
  sm: PropTypes.oneOf(alignments),
  /** Alignment for the md breakpoint */
  md: PropTypes.oneOf(alignments),
  /** Alignment for the lg breakpoint */
  lg: PropTypes.oneOf(alignments)
};

ReverseDirection.defaultProps = {
  xs: 'center',
  sm: 'center',
  md: 'center',
  lg: 'center'
};

export { ReverseDirection };
